/* Sticky add-to-cart bar behaviour:
   - shows the bar after the visitor scrolls past the main buy buttons
   - keeps the variant select, hidden input, price and button state in sync
*/
(function () {
  function init() {
    var bar = document.querySelector('.ct-sticky-atc');
    if (!bar) return;

    var mainSubmit = document.querySelector('.product-form__submit');
    var sentinel = mainSubmit || document.querySelector('.product__info-wrapper');

    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var pastSentinel =
              !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', pastSentinel);
          });
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 700);
      });
    }

    var select = bar.querySelector('[data-sticky-variant-select]');
    var hiddenInput = bar.querySelector('[data-sticky-variant-input]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var button = bar.querySelector('.ct-sticky-atc__button');

    if (select && hiddenInput) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        hiddenInput.value = option.value;

        if (priceEl) {
          var html = option.dataset.price || '';
          if (option.dataset.compare) {
            html +=
              ' <s style="color: var(--ct-muted); font-weight: 400;">' +
              option.dataset.compare +
              '</s>';
          }
          priceEl.innerHTML = html;
        }

        if (button) {
          button.disabled = option.disabled;
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
